const config = {
    Sidebar_drawer: true,
    mini_sidebar: false, // Mode vertical classique
    setRTLLayout: false, // RTL layout
    actTheme: 'BLUE_THEME', // Thème MatDash
    boxed: true, // Boxed layout comme MatDash
    setBorderCard: false
}

export default config;
